// extracted by mini-css-extract-plugin
export default {"container":"container___vaDEk","FForbid":"FForbid___YdEId","content":"content___Sw6hr"};